import { NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, Inject, OnDestroy } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { get } from 'lodash';
import { IWidgetGlobalData, WIDGET_GLOBAL_DATA } from 'scw-digital-boards-widgets';
import { CountdownManager } from '../countdown/countdown-manager.class';

export interface IActionDetailDialogConfig {
  cancelButtonText: string;
  itemKey: string;
  countdownManager?: CountdownManager;
}

@Component({
  imports: [NgIf, MatDialogActions, MatButton],
  selector: 'app-action-detail-dialog',
  standalone: true,
  template: `
    <div class="iframe-container">
      <iframe [src]="safeUrl" frameborder="0" width="100%" style="height: 80vh;" allow="camera;"></iframe>
    </div>
    <div *ngIf="!hideActions" mat-dialog-actions align="end">
      <button *ngIf="data.cancelButtonText" mat-button (click)="onDismiss()">
        {{ data.cancelButtonText }}
      </button>
    </div>
  `,
})
export class ActionDetailDialogComponent implements OnDestroy {
  public safeUrl: SafeResourceUrl;
  public hideActions = false;

  constructor(
    public dialogRef: MatDialogRef<ActionDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IActionDetailDialogConfig,
    @Inject(WIDGET_GLOBAL_DATA) private globalData: IWidgetGlobalData,
    private readonly sanitizer: DomSanitizer,
    private readonly cdr: ChangeDetectorRef,
  ) {
    const fullUrl = `${this.globalData.actionTrackerUrl}/item/${this.data.itemKey}`;
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fullUrl);
  }

  @HostListener('window:message', ['$event'])
  public handleMessage(event: MessageEvent): void {
    const origin: string = this.globalData.actionTrackerUrl;

    if (origin && !origin.includes(event.origin)) {
      return;
    }

    if (get(event.data, 'type') === 'DIALOG_CLOSED') {
      this.dialogRef.close();
    }

    if (get(event.data, 'type') === 'DIALOG_OPENED') {
      this.hideActions = true;
      this.cdr.detectChanges();
    }
  }

  public onDismiss(): void {
    this.dialogRef.close();
  }

  public ngOnDestroy(): void {
    this.data.countdownManager?.timeoutSubject.next(true);
  }
}
